<template>
  <div class="molecule-list-resource_container">
    <div class="molecule-list-resource_column">
      <div class="column_container w-30">
        <label class="column__label w-100">{{ columns[0].title }}</label>
      </div>
      <div class="column_sub-container w-70">
        <label class="column__label w-30 padding-left-20px">{{
          columns[1].title
        }}</label>
        <label class="column__label w-30 padding-left-15px">{{
          columns[2].title
        }}</label>
        <label class="column__label w-40 padding-left-7px padding-right-15px">{{
          columns[3].title
        }}</label>
      </div>
    </div>

    <div
      v-for="(row, index) in rows"
      :key="index"
      class="molecule-list-resource_row"
    >
      <div v-if="policy === 'view' && rows[index].isEnabled">
        <molecule-item-resource
          v-if="unitListByType(row.resource)"
          :column="columns"
          v-model="rows[index]"
          :index="index"
          :policy="policy"
          :unitList="unitListByType(row.resource)"
          :isValidateTrigger="isValidateTrigger"
          :isEdit="isEditPath"
          @error="errorInput"
        ></molecule-item-resource>
      </div>
      <div v-else-if="policy !== 'view'">
        <molecule-item-resource
          v-if="unitListByType(row.resource)"
          :column="columns"
          v-model="rows[index]"
          :index="index"
          :policy="policy"
          :unitList="unitListByType(row.resource)"
          :isClickApply="isClickApply"
          :isValidateTrigger="isValidateTrigger"
          :isEdit="isEditPath"
          @error="errorInput"
        ></molecule-item-resource>
      </div>
    </div>
  </div>
</template>

<script>
import MoleculeItemResource from "./MoleculeItemResource.vue"
export default {
  name: "MoleculeListResource",
  components: { MoleculeItemResource },
  props: {
    policy: {
      type: String,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    unitList: {
      type: Object,
      required: true,
    },
    isEditPath: {
      type: Boolean,
      required: false,
      default: false,
    },
    isClickApply: {
      type: Boolean,
      required: false,
      default: false,
    },
    isValidateTrigger: {
      type: Boolean,
      required: false,
      default: false,
    },
    value: {
      type: Array,
      required: true,
    },
  },
  emits: ["errorInput"],
  data() {
    return {
      rowsData: [],
      isError: [],
    }
  },
  computed: {
    rows: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
  },
  methods: {
    errorInput(error, index) {
      this.isError[index] = error
      if (this.isError.length === this.rows.length) {
        this.$emit("errorInput", this.isError.find((e) => e) ? true : false)
      }
    },
    unitListByType(type) {
      if (type) {
        let units = []
        if (type === "CPU") {
          units = this.unitList.cpu
        } else if (type === "Memory") {
          units = this.unitList.memory
        } else if (type === "Storage") {
          units = this.unitList.storage
        }
        if (units && units.length !== 0) {
          return units
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
label {
  margin-bottom: 0;
}

.molecule-list-resource_container {
  margin-top: 26px;
}
.molecule-list-resource_column {
  display: none;
}
.column__label {
  color: #6e6b7b;
}

.molecule-list-resource_row {
  margin-bottom: 10px;
}

.padding-left-7px {
  padding-left: 7px;
}
.padding-left-15px {
  padding-left: 15px;
}
.padding-left-20px {
  padding-left: 20px;
}
.padding-right-15px {
  padding-right: 15px;
}

// Small devices (landscape phones, 576px and up)
@media screen and (min-width: 576px) {
  .molecule-list-resource_column {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    width: 100%;
  }
  .column_container {
    display: flex;
    align-items: center;
  }
  .column_sub-container {
    display: flex;
    align-items: center;
  }
  .column__label {
    font-size: 14px;
    //text-align: center;
  }
}

// Medium devices (tablets, 768px and up)
@media screen and (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media screen and (min-width: 992px) {
}

// X-Large devices (large desktops, 1200px and up)
@media screen and (min-width: 1200px) {
}
</style>
